/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { cancelUrlaubsantrag$Json } from '../fn/urlaubsantrag/cancel-urlaubsantrag-json';
import { CancelUrlaubsantrag$Json$Params } from '../fn/urlaubsantrag/cancel-urlaubsantrag-json';
import { cancelUrlaubsantrag$Plain } from '../fn/urlaubsantrag/cancel-urlaubsantrag-plain';
import { CancelUrlaubsantrag$Plain$Params } from '../fn/urlaubsantrag/cancel-urlaubsantrag-plain';
import { createUrlaubsantrag$Json } from '../fn/urlaubsantrag/create-urlaubsantrag-json';
import { CreateUrlaubsantrag$Json$Params } from '../fn/urlaubsantrag/create-urlaubsantrag-json';
import { createUrlaubsantrag$Plain } from '../fn/urlaubsantrag/create-urlaubsantrag-plain';
import { CreateUrlaubsantrag$Plain$Params } from '../fn/urlaubsantrag/create-urlaubsantrag-plain';
import { getTotalCountOpenUrlaubsantraege$Json } from '../fn/urlaubsantrag/get-total-count-open-urlaubsantraege-json';
import { GetTotalCountOpenUrlaubsantraege$Json$Params } from '../fn/urlaubsantrag/get-total-count-open-urlaubsantraege-json';
import { getTotalCountOpenUrlaubsantraege$Plain } from '../fn/urlaubsantrag/get-total-count-open-urlaubsantraege-plain';
import { GetTotalCountOpenUrlaubsantraege$Plain$Params } from '../fn/urlaubsantrag/get-total-count-open-urlaubsantraege-plain';
import { getUrlaubsantraege$Json } from '../fn/urlaubsantrag/get-urlaubsantraege-json';
import { GetUrlaubsantraege$Json$Params } from '../fn/urlaubsantrag/get-urlaubsantraege-json';
import { getUrlaubsantraege$Plain } from '../fn/urlaubsantrag/get-urlaubsantraege-plain';
import { GetUrlaubsantraege$Plain$Params } from '../fn/urlaubsantrag/get-urlaubsantraege-plain';
import { getUrlaubsantraegeForMitarbeiter$Json } from '../fn/urlaubsantrag/get-urlaubsantraege-for-mitarbeiter-json';
import { GetUrlaubsantraegeForMitarbeiter$Json$Params } from '../fn/urlaubsantrag/get-urlaubsantraege-for-mitarbeiter-json';
import { getUrlaubsantraegeForMitarbeiter$Plain } from '../fn/urlaubsantrag/get-urlaubsantraege-for-mitarbeiter-plain';
import { GetUrlaubsantraegeForMitarbeiter$Plain$Params } from '../fn/urlaubsantrag/get-urlaubsantraege-for-mitarbeiter-plain';
import { updateUrlaubsantrag$Json } from '../fn/urlaubsantrag/update-urlaubsantrag-json';
import { UpdateUrlaubsantrag$Json$Params } from '../fn/urlaubsantrag/update-urlaubsantrag-json';
import { updateUrlaubsantrag$Plain } from '../fn/urlaubsantrag/update-urlaubsantrag-plain';
import { UpdateUrlaubsantrag$Plain$Params } from '../fn/urlaubsantrag/update-urlaubsantrag-plain';
import { UrlaubsantragDto } from '../models/urlaubsantrag-dto';

@Injectable({ providedIn: 'root' })
export class UrlaubsantragApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUrlaubsantraege()` */
  static readonly GetUrlaubsantraegePath = '/v1/urlaubsantraege';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUrlaubsantraege$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUrlaubsantraege$Plain$Response(params?: GetUrlaubsantraege$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UrlaubsantragDto>>> {
    return getUrlaubsantraege$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUrlaubsantraege$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUrlaubsantraege$Plain(params?: GetUrlaubsantraege$Plain$Params, context?: HttpContext): Observable<Array<UrlaubsantragDto>> {
    return this.getUrlaubsantraege$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UrlaubsantragDto>>): Array<UrlaubsantragDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUrlaubsantraege$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUrlaubsantraege$Json$Response(params?: GetUrlaubsantraege$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UrlaubsantragDto>>> {
    return getUrlaubsantraege$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUrlaubsantraege$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUrlaubsantraege$Json(params?: GetUrlaubsantraege$Json$Params, context?: HttpContext): Observable<Array<UrlaubsantragDto>> {
    return this.getUrlaubsantraege$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UrlaubsantragDto>>): Array<UrlaubsantragDto> => r.body)
    );
  }

  /** Path part for operation `createUrlaubsantrag()` */
  static readonly CreateUrlaubsantragPath = '/v1/urlaubsantraege';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createUrlaubsantrag$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createUrlaubsantrag$Plain$Response(params?: CreateUrlaubsantrag$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UrlaubsantragDto>> {
    return createUrlaubsantrag$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createUrlaubsantrag$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createUrlaubsantrag$Plain(params?: CreateUrlaubsantrag$Plain$Params, context?: HttpContext): Observable<UrlaubsantragDto> {
    return this.createUrlaubsantrag$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UrlaubsantragDto>): UrlaubsantragDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createUrlaubsantrag$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createUrlaubsantrag$Json$Response(params?: CreateUrlaubsantrag$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<UrlaubsantragDto>> {
    return createUrlaubsantrag$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createUrlaubsantrag$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createUrlaubsantrag$Json(params?: CreateUrlaubsantrag$Json$Params, context?: HttpContext): Observable<UrlaubsantragDto> {
    return this.createUrlaubsantrag$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<UrlaubsantragDto>): UrlaubsantragDto => r.body)
    );
  }

  /** Path part for operation `updateUrlaubsantrag()` */
  static readonly UpdateUrlaubsantragPath = '/v1/urlaubsantraege/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUrlaubsantrag$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUrlaubsantrag$Plain$Response(params: UpdateUrlaubsantrag$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UrlaubsantragDto>> {
    return updateUrlaubsantrag$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUrlaubsantrag$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUrlaubsantrag$Plain(params: UpdateUrlaubsantrag$Plain$Params, context?: HttpContext): Observable<UrlaubsantragDto> {
    return this.updateUrlaubsantrag$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UrlaubsantragDto>): UrlaubsantragDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUrlaubsantrag$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUrlaubsantrag$Json$Response(params: UpdateUrlaubsantrag$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<UrlaubsantragDto>> {
    return updateUrlaubsantrag$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUrlaubsantrag$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUrlaubsantrag$Json(params: UpdateUrlaubsantrag$Json$Params, context?: HttpContext): Observable<UrlaubsantragDto> {
    return this.updateUrlaubsantrag$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<UrlaubsantragDto>): UrlaubsantragDto => r.body)
    );
  }

  /** Path part for operation `cancelUrlaubsantrag()` */
  static readonly CancelUrlaubsantragPath = '/v1/urlaubsantraege/{id}/cancel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelUrlaubsantrag$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelUrlaubsantrag$Plain$Response(params: CancelUrlaubsantrag$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UrlaubsantragDto>> {
    return cancelUrlaubsantrag$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cancelUrlaubsantrag$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelUrlaubsantrag$Plain(params: CancelUrlaubsantrag$Plain$Params, context?: HttpContext): Observable<UrlaubsantragDto> {
    return this.cancelUrlaubsantrag$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UrlaubsantragDto>): UrlaubsantragDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelUrlaubsantrag$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelUrlaubsantrag$Json$Response(params: CancelUrlaubsantrag$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<UrlaubsantragDto>> {
    return cancelUrlaubsantrag$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cancelUrlaubsantrag$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelUrlaubsantrag$Json(params: CancelUrlaubsantrag$Json$Params, context?: HttpContext): Observable<UrlaubsantragDto> {
    return this.cancelUrlaubsantrag$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<UrlaubsantragDto>): UrlaubsantragDto => r.body)
    );
  }

  /** Path part for operation `getTotalCountOpenUrlaubsantraege()` */
  static readonly GetTotalCountOpenUrlaubsantraegePath = '/v1/urlaubsantraege/open';

  /**
   * Holt die Anzahl an offenen Urlaubsantraegen (für die Unit).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTotalCountOpenUrlaubsantraege$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalCountOpenUrlaubsantraege$Plain$Response(params?: GetTotalCountOpenUrlaubsantraege$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return getTotalCountOpenUrlaubsantraege$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt die Anzahl an offenen Urlaubsantraegen (für die Unit).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTotalCountOpenUrlaubsantraege$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalCountOpenUrlaubsantraege$Plain(params?: GetTotalCountOpenUrlaubsantraege$Plain$Params, context?: HttpContext): Observable<number> {
    return this.getTotalCountOpenUrlaubsantraege$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * Holt die Anzahl an offenen Urlaubsantraegen (für die Unit).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTotalCountOpenUrlaubsantraege$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalCountOpenUrlaubsantraege$Json$Response(params?: GetTotalCountOpenUrlaubsantraege$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return getTotalCountOpenUrlaubsantraege$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt die Anzahl an offenen Urlaubsantraegen (für die Unit).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTotalCountOpenUrlaubsantraege$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTotalCountOpenUrlaubsantraege$Json(params?: GetTotalCountOpenUrlaubsantraege$Json$Params, context?: HttpContext): Observable<number> {
    return this.getTotalCountOpenUrlaubsantraege$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `getUrlaubsantraegeForMitarbeiter()` */
  static readonly GetUrlaubsantraegeForMitarbeiterPath = '/v1/urlaubsantraege/mitarbeiter/{mitarbeiterId}';

  /**
   * Holt alle Urlaubsanträge für einen Mitarbeiter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUrlaubsantraegeForMitarbeiter$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUrlaubsantraegeForMitarbeiter$Plain$Response(params: GetUrlaubsantraegeForMitarbeiter$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UrlaubsantragDto>>> {
    return getUrlaubsantraegeForMitarbeiter$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt alle Urlaubsanträge für einen Mitarbeiter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUrlaubsantraegeForMitarbeiter$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUrlaubsantraegeForMitarbeiter$Plain(params: GetUrlaubsantraegeForMitarbeiter$Plain$Params, context?: HttpContext): Observable<Array<UrlaubsantragDto>> {
    return this.getUrlaubsantraegeForMitarbeiter$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UrlaubsantragDto>>): Array<UrlaubsantragDto> => r.body)
    );
  }

  /**
   * Holt alle Urlaubsanträge für einen Mitarbeiter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUrlaubsantraegeForMitarbeiter$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUrlaubsantraegeForMitarbeiter$Json$Response(params: GetUrlaubsantraegeForMitarbeiter$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UrlaubsantragDto>>> {
    return getUrlaubsantraegeForMitarbeiter$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt alle Urlaubsanträge für einen Mitarbeiter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUrlaubsantraegeForMitarbeiter$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUrlaubsantraegeForMitarbeiter$Json(params: GetUrlaubsantraegeForMitarbeiter$Json$Params, context?: HttpContext): Observable<Array<UrlaubsantragDto>> {
    return this.getUrlaubsantraegeForMitarbeiter$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UrlaubsantragDto>>): Array<UrlaubsantragDto> => r.body)
    );
  }

}
